import { render, staticRenderFns } from "./AppTableV2.vue?vue&type=template&id=51dcd437&scoped=true&"
import script from "./AppTableV2.vue?vue&type=script&lang=js&"
export * from "./AppTableV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcd437",
  null
  
)

export default component.exports